
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { DepartmentItemProps } from ".";
import { loading, update } from "store/department";

interface ApiDepartmentUpdateInputProps extends DepartmentItemProps {
}

type ApiDepartmentUpdateOutputProps = OutputBaseProps<{ item: DepartmentItemProps; }, DepartmentItemProps>;

export const apiDepartmentUpdate = async (data: ApiDepartmentUpdateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.put<ApiDepartmentUpdateOutputProps>("/api/department/update", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(update({ data: res.data.item }));
    }
    return res;
};